export const CertificationsData = [
  { id: 1, name: "Salesforce Certified Administrator", icon: "admin", url: null },
  { id: 2, name: "Salesforce Certified Platform Developer I (PD1)", icon: "pd1", url: null },
  { id: 3, name: "Copado Source Format Pipeline 1 & 2", icon: "copado", url: null },
  { id: 4, name: "Copado Extension Builder", icon: "copado", url: null },
  { id: 5, name: "Copado Metadata Pipeline 1 & 2", icon: "copado", url: null },
  { id: 6, name: "Salesforce Data Cloud Consultant", icon: "data", url: null },
  { id: 7, name: "Salesforce AI Associate", icon: "ai", url: null },
];
